import ApiService from "../../../common/api.service";

export async function SetAlert({ commit }, data) {
  ApiService.init();
  ApiService.setHeader();
  commit("SET_ALERT_SUCCESS", {
    results: data
  });
}
